import { lazy } from 'react';
import type { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const RoutesPage = lazy(() => import("../pages/routes/page"));
const RouteDetailPage = lazy(() => import("../pages/route-detail/page"));
const StartingPointsPage = lazy(() => import("../pages/starting-points/page"));
const PointsOfInterestPage = lazy(() => import("../pages/points-of-interest/page"));
const GalleryPage = lazy(() => import("../pages/gallery/page"));
const WeatherPage = lazy(() => import("../pages/weather/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const LegalPage = lazy(() => import("../pages/legal/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/poti", element: <RoutesPage /> },
  { path: "/poti/:slug", element: <RouteDetailPage /> },
  { path: "/startne-tocke", element: <StartingPointsPage /> },
  { path: "/zanimivosti", element: <PointsOfInterestPage /> },
  { path: "/galerija", element: <GalleryPage /> },
  { path: "/vreme", element: <WeatherPage /> },
  { path: "/o-stezi", element: <AboutPage /> },
  { path: "/kontakt", element: <ContactPage /> },
  { path: "/pravno/:slug", element: <LegalPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;